// removed by extract-text-webpack-plugin
module.exports = {"select":"magazines_1t8gV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/editors/FontHeight/styles.scss
// module id = 1213
// module chunks = 1